'use client'

import { TopNavV5MobileBar } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5MobileBar'
import { TopNavV5MobileSlidingPanel } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5MobileSlidingPanel'

export const TopNavV5Mobile = () => {
  return (
    <nav className="relative overflow-x-clip lg:hidden">
      <div className="z-50 h-12 w-full bg-bodi-black-text font-medium text-bodi-white">
        <TopNavV5MobileBar />
      </div>
      <TopNavV5MobileSlidingPanel />
    </nav>
  )
}
